import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { fetchDiets } from 'actions/Diets';
import { fetchPackage } from 'actions/Packages';
import { post, put } from 'helpers/apiHelpers';
import { combineStyles } from 'helpers/helpers';
import withStyles from '@material-ui/core/styles/withStyles';
import buttonsStyle from 'assets/jss/material-dashboard-pro-react/views/buttonsStyle.jsx';
import extendedFormsStyle from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle';
import { withTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { useGetCompanyDefaultLanguage } from 'hooks/redux/Translatable/useTranslatableLanguages';

import FormFiltersView from './FormFilters.view';

const FormFiltersContainer = ({
  match,
  location,
  // eslint-disable-next-line no-shadow -- FIXME
  fetchDiets,
  // eslint-disable-next-line no-shadow -- FIXME
  fetchPackage,
  history,
  t,
  diets,
  classes,
}) => {
  const companyDefaultLanguage = useGetCompanyDefaultLanguage();

  const [state, setState] = useState({
    modal: null,
    modalOptions: [],
    name: '',
    diets: [],
    image: null,
    position: 0,
    imageUrl: null,
    active: false,
    description: '',
    disabledDiets: [],
    mainImage: null,
    mainImageUrl: null,
  });
  const [isLoading, setIsLoading] = useState(false);
  const packageId = match.params.id;
  const isEdit = location.pathname.includes('edit');

  // eslint-disable-next-line react-hooks/exhaustive-deps -- FIXME
  useEffect(async () => {
    await fetchDiets();

    if (isEdit) {
      // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
      fetchPackage(packageId, { translations: true }).then(response => {
        const PACKAGE = response;

        setState(prev => ({
          ...prev,
          name: PACKAGE.name,
          image: PACKAGE.image?.['@id'] || null,
          diets: PACKAGE.diets,
          active: PACKAGE.active,
          position: PACKAGE.position,
          description: PACKAGE.description,
          disabledDiets: PACKAGE.disabledDiets || [],
          imageUrl: PACKAGE.image?.contentUrl || null,
          mainImage: PACKAGE.mainImage?.['@id'] || null,
          mainImageUrl: PACKAGE.mainImage?.contentUrl || null,
        }));
        setIsLoading(true);
      });
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-expressions -- FIXME
    !isEdit && setIsLoading(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- FIXME
  }, []);

  const handleInputChange = (event, value) => {
    const newValue = event.target.value;
    setState(prev => ({
      ...prev,
      [event.target.name]: value || newValue,
    }));
  };

  const handleSelect = ({ target: { name, value } }) => {
    setState(prevState => ({
      ...prevState,
      [name]: value,
    }));
  };

  const getImage = (stateName, data) => {
    setState(prev => ({
      ...prev,
      [stateName]: data?.['@id'] || null,
      [`${stateName}Url`]: data?.contentUrl || null,
    }));
  };

  const removeImage = stateName => {
    setState(prev => ({
      ...prev,
      [stateName]: null,
      [`${stateName}Url`]: null,
    }));
  };

  const handleToggle = e => {
    setState(prev => ({ ...prev, [e.target.name]: !state[e.target.name] }));
  };

  const validateForm = () =>
    state.name['@ContentTranslation'][companyDefaultLanguage] &&
    state.diets.length > 0;

  // eslint-disable-next-line consistent-return -- FIXME
  const handleSubmit = () => {
    if (!validateForm()) {
      return toast.error(t('form.fillAllRequiredFields'));
    }
    if (state.position < 1) {
      return toast.error(t('form.orderStarts'));
    }

    const data = {
      name: state.name,
      // eslint-disable-next-line radix -- FIXME
      position: parseInt(state.position),
      description: state.description,
      active: state.active,
      image: state.image,
      disabledDiets: state.disabledDiets,
      diets: state.diets,
      mainImage: state.mainImage,
    };

    const action = isEdit
      ? put(`/packages/${packageId}`, data)
      : post('/packages', data);

    // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
    action.then(() => history.push('/admin/packages'));
  };

  const props = {
    t,
    diets,
    classes,
    state,
    isLoading,
    isEdit,
    packageId,
    handleInputChange,
    handleSelect,
    getImage,
    removeImage,
    handleToggle,
    handleSubmit,
  };
  return <FormFiltersView props={props} />;
};
const combinedStyles = combineStyles(extendedFormsStyle, buttonsStyle);

const mapStateToProps = state => ({
  mealSizes: state.MealSizes.mealSizes,
  mealType: state.MealTypes.mealType,
  diets: state.Diets.diets,
});

const mapDispatchToProps = {
  fetchPackage,
  fetchDiets,
};

export default withTranslation()(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withStyles(combinedStyles)(FormFiltersContainer))
);
